import type { ReactNode } from "react";

interface ReadLayoutProps {
  children: ReactNode;
  /**
   * Omitted when there is nothing to index. Passing a component that renders
   * null would still leave its column standing and the body off-centre, so the
   * decision has to be the caller's.
   */
  index?: ReactNode;
}

/**
 * A long column with an index beside it. The index comes first in the DOM so
 * it is reachable before the body on a keyboard and reads first on one column.
 */
export function ReadLayout({ children, index }: Readonly<ReadLayoutProps>) {
  if (!index) {
    return (
      <div className="read-solo wrap">
        <div>{children}</div>
      </div>
    );
  }

  return (
    <div className="index-layout wrap">
      {index}
      <div>{children}</div>
    </div>
  );
}
